// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import "../styles/SavingReport.css";

// const SavingReport = () => {
//   const [activeTab, setActiveTab] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accountType, setAccountType] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [accountsData, setAccountsData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const rowsPerPage = 5;

//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const superAdminId = localStorage.getItem("adminuserId") || 14;

//       const response = await axios.get("https://payyug.in/api/get-all-saving-account", {
//         params: { superAdminId },
//       });

//       if (Array.isArray(response.data.accounts)) {
//         setAccountsData(response.data.accounts);
//       } else {
//         setAccountsData([]);
//       }
//     } catch (err) {
//       console.error("Error fetching saving accounts:", err);
//       setError("Failed to load saving accounts.");
//       setAccountsData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAccounts();
//   }, []);

//   const filteredData = useMemo(() => {
//     let data = [...accountsData];

//     if (activeTab !== "All") data = data.filter((item) => item.status === activeTab);

//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }

//     if (accountType) data = data.filter((item) => item.accountType === accountType);

//     if (fromDate)
//       data = data.filter((item) => new Date(item.openedDate) >= new Date(fromDate));
//     if (toDate)
//       data = data.filter((item) => new Date(item.openedDate) <= new Date(toDate));

//     return data;
//   }, [accountsData, activeTab, searchQuery, accountType, fromDate, toDate]);

//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData =
//     activeTab === "All"
//       ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
//       : filteredData;

// const approveAccount = async (id) => {
//   try {
//     const adminId = localStorage.getItem("adminuserId") || 1;

//     await axios.put(`https://payyug.in/api/saving-account/approve/${id}`, {
//       approvedBy: adminId
//     });

//     alert("Account Approved Successfully!");
//     fetchAccounts();  // refresh list
//   } catch (error) {
//     console.error("Approve Error:", error);
//     alert("Failed to approve account");
//   }
// };

// const rejectAccount = async (id) => {
//   const adminId = localStorage.getItem("adminuserId") || 1;
//   const reason = prompt("Enter Reject Reason:");

//   if (!reason) return alert("Reject reason is required!");

//   try {
//     await axios.put(`https://payyug.in/api/saving-account/reject/${id}`, {
//       rejectedBy: adminId,
//       rejectReason: reason,
//     });

//     alert("Account Rejected Successfully!");
//     fetchAccounts(); // refresh list
//   } catch (error) {
//     console.error("Reject Error:", error);
//     alert("Failed to reject account");
//   }
// };

//   return (
//     <div className="SR-container">
//       <h2 className="SR-title">Saving Account Report</h2>

//       {/* Filters */}
//       <div className="SR-filter-box">
//         <input
//           type="text"
//           placeholder="Search name, account no..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />

//         <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
//           <option value="">All Account Types</option>
//           <option value="Saving">Saving</option>
//           <option value="Current">Current</option>
//         </select>

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <button className="SR-apply" onClick={() => setCurrentPage(1)}>Apply</button>
//         <button
//           className="SR-reset"
//           onClick={() => {
//             setSearchQuery("");
//             setAccountType("");
//             setFromDate("");
//             setToDate("");
//             setActiveTab("All");
//           }}
//         >
//           Reset
//         </button>
//       </div>

//       {/* Loading / Error */}
//       {loading && <p className="SR-loading">Loading accounts...</p>}
//       {error && <p className="SR-error">{error}</p>}

//       {/* Table */}
//       <div className="SR-table-wrapper">
//         <table className="SR-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Account No</th>
//               <th>Customer Name</th>
//               <th>Account Type</th>
//               <th>Status</th>
//               <th>Opened Date</th>
//               <th>Opening Balance</th>
//               <th>Current Balance</th>
//               <th>Refer ID</th>
//               <th>Nominee ID</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{item.accountNumber || "--"}</td>
//                   <td>{item.customerName || "--"}</td>
//                   <td>{item.accountType || "--"}</td>
//                   <td>{item.status || "--"}</td>
//                   <td>{item.openedDate?.split("T")[0] || "--"}</td>
//                   <td>₹{item.openingBalance || "0"}</td>
//                   <td>₹{item.currentBalance || "0"}</td>
//                   <td>{item.referId || "--"}</td>
//                   <td>{item.nomineeId || "--"}</td>
//                <div style={{ display: "flex", gap: "6px" }}>
//   {item.status === "Pending" && (
//     <>
//       <button
//         className="SR-approve-btn"
//         style={{ background: "green", color: "white", padding: "4px 8px", borderRadius: "4px", border: "none" }}
//         onClick={() => approveAccount(item.id)}
//       >
//         Accept
//       </button>

//       <button
//         className="SR-reject-btn"
//         style={{ background: "red", color: "white", padding: "4px 8px", borderRadius: "4px", border: "none" }}
//         onClick={() => rejectAccount(item.id)}
//       >
//         Reject
//       </button>
//     </>
//   )}

//   {item.status !== "Pending" && (
//     <span style={{ fontWeight: "bold", color: "#555" }}>
//       {item.status}
//     </span>
//   )}
// </div>

//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" style={{ textAlign: "center" }}>No Data Found</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination (Centered) */}
//       {activeTab === "All" && filteredData.length > rowsPerPage && (
//         <div className="SR-pagination">
//           <button
//             onClick={() => setCurrentPage(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             ⬅ Prev
//           </button>

//           <span>
//             Page {currentPage} of {totalPages}
//           </span>

//           <button
//             onClick={() => setCurrentPage(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SavingReport;

// import React, { useState, useEffect, useMemo } from "react";
// import axios from "axios";
// import "../styles/SavingReport.css";
// import { Trash } from "lucide-react";

// const SavingReport = () => {
//   const [activeTab, setActiveTab] = useState("All");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [accountType, setAccountType] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [accountsData, setAccountsData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const rowsPerPage = 10;

//   // Fetch Saving Accounts
//   const fetchAccounts = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const superAdminId = localStorage.getItem("adminuserId") || 14;

//       const response = await axios.get(
//         `https://payyug.in/api/get-all-saving-account`,
//         { params: { superAdminId } }
//       );

//       const accounts = Array.isArray(response?.data?.accounts)
//       ? response.data.accounts
//       : [];

//     const filteredAccounts = accounts.filter(
//       (acc) =>
//         acc?.status &&
//         acc.status.trim().toLowerCase() !== "pending"
//     );

//     setAccountsData(filteredAccounts)
//     } catch (err) {
//       console.error("Error fetching saving accounts:", err);
//       setError("Failed to load saving accounts.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAccounts();
//   }, []);

//   // Filtering Logic
//   const filteredData = useMemo(() => {
//     let data = [...accountsData];

//     if (activeTab !== "All") data = data.filter((item) => item.status === activeTab);
//     if (searchQuery.trim()) {
//       data = data.filter((item) =>
//         Object.values(item)
//           .join(" ")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );
//     }
//     if (accountType) data = data.filter((item) => item.accountType === accountType);
//     if (fromDate) data = data.filter((item) => new Date(item.openedDate) >= new Date(fromDate));
//     if (toDate) data = data.filter((item) => new Date(item.openedDate) <= new Date(toDate));

//     return data;
//   }, [accountsData, activeTab, searchQuery, accountType, fromDate, toDate]);

//   const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData =
//     activeTab === "All"
//       ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
//       : filteredData;

//   // Approve Account API
//   const approveAccount = async (id) => {
//     try {
//       const adminId = localStorage.getItem("adminuserId") || 1;

//       await axios.put(
//         // `https://payyug.in/api/saapproveSavingAccount/${id}`,
//         `https://payyug.in/api/create-saving-account/approve/${id}`,
//         { approvedBy: adminId }
//       );

//       alert("Account Approved Successfully!");
//       fetchAccounts();
//     } catch (error) {
//       console.error("Approve Error:", error);
//       alert("Failed to approve account");
//     }
//   };

//   // Reject Account API
//   const rejectAccount = async (id) => {
//     const adminId = localStorage.getItem("adminuserId") || 1;
//     const reason = prompt("Enter Reject Reason:");

//     if (!reason) return alert("Reject reason is required!");

//     try {
//       await axios.put(
//         // `https://payyug.in/api/saving-account/reject/${id}`,
//         `https://payyug.in/api//create-saving-account/reject/${id}`,
//         { rejectedBy: adminId, rejectReason: reason }
//       );

//       alert("Account Rejected Successfully!");
//       fetchAccounts();
//     } catch (error) {
//       console.error("Reject Error:", error);
//       alert("Failed to reject account");
//     }
//   };

//       // delete account
//     const handleDelete=async(account,accountNo)=>{
//       const confirm=window.confirm(`Are you sure to delete this Account= ${accountNo}`)
//       if(confirm){
//         // await axios.delete(`https://payyug.in/api/deposit/list/${account.id}`)
//       }
//     }

//   return (
//     <div className="SR-container">
//       <h2 className="SR-title">Saving Account Report</h2>

//       {/* Filters */}
//       <div className="SR-filter-box">
//         <input
//           type="text"
//           placeholder="Search name, account no..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />

//         <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
//           <option value="">All Account Types</option>
//           <option value="Saving">Saving</option>
//           <option value="Current">Current</option>
//         </select>

//         <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

//         <button className="SR-apply" onClick={() => setCurrentPage(1)}>Apply</button>
//         <button
//           className="SR-reset"
//           onClick={() => {
//             setSearchQuery("");
//             setAccountType("");
//             setFromDate("");
//             setToDate("");
//             setActiveTab("All");
//           }}
//         >
//           Reset
//         </button>
//       </div>

//       {loading && <p className="SR-loading">Loading accounts...</p>}
//       {error && <p className="SR-error">{error}</p>}

//       {/* Table */}
//       <div className="SR-table-wrapper">
//         <table className="SR-table">
//           <thead>
//             <tr>
//               <th>SN</th>
//               <th>Account No</th>
//               <th>Customer Name</th>
//               <th>Account Type</th>
//               <th>Scheme Name</th>
//               <th>Opening Date</th>
//               <th>Opening Balance</th>
//               <th>Current Balance</th>
//               <th>Refer ID</th>
//               <th>Nominee ID</th>
//               <th>Status</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {paginatedData.length > 0 ? (
//               paginatedData.map((item, index) => (
//                 <tr key={item.id}>
//                   <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
//                   <td>{item.accountNumber || "N/A"}</td>
//                   <td>{item.customerName || "N/A"}</td>
//                   <td>{item.accountType || "N/A"}</td>
//                   <td>{item?.schemeDetails?.serviceName || "N/A"}</td>
//                   <td>{new Date(item.openedDate).toLocaleDateString("en-GB") || "N/A"}</td>
//                   <td>₹{item.openingBalance || "0"}</td>
//                   <td>₹{item.currentBalance || "0"}</td>
//                   <td>{item.referId || "N/A"}</td>
//                   <td>{item.nomineeId || "N/A"}</td>
//                   <td>{item.status || "N/A"}</td>
//                  <td>
//                    <button
//                   style={{color:"red",backgroundColor:"transparent"}}
//                         onClick={()=>handleDelete(item.id,item.accountNumber)}
//                       >
//                         <Trash/>
//                       </button>
//                  </td>

//                   {/* FIXED: Action Column */}
//                   {/* <td>
//                     <div className="SR-action-btns">
//                       {item.status === "Pending" ? (
//                         <>
//                           <button
//                             className="SR-approve-btn"
//                             onClick={() => approveAccount(item.id)}
//                           >
//                             Accept
//                           </button>

//                           <button
//                             className="SR-reject-btn"
//                             onClick={() => rejectAccount(item.id)}
//                           >
//                             Reject
//                           </button>
//                         </>
//                       ) : (
//                         <span className="SR-status-label">{item.status}</span>
//                       )}
//                     </div>
//                   </td> */}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="11" style={{ textAlign: "center" }}>
//                   No Data Found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       {activeTab === "All" && filteredData.length > rowsPerPage && (
//         <div className="SR-pagination">
//           <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
//             ⬅ Prev
//           </button>
//           <span>Page {currentPage} of {totalPages}</span>
//           <button
//             onClick={() => setCurrentPage(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           >
//             Next ➡
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SavingReport;



import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "../styles/SavingReport.css";
import { Trash } from "lucide-react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../../redux/slices/employeeReportSlice";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];

const SavingReport = () => {
  const { list: employee } = useSelector((state) => state.employeeReport);
  const dispatch = useDispatch();
  
  // UI States (Ye typing ke waqt change hongi)
  const [searchQuery, setSearchQuery] = useState("");
  const [accountType, setAccountType] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [activeTab, setActiveTab] = useState("All");

  // Filter Trigger State (Sirf button click par update hogi)
  const [appliedFilters, setAppliedFilters] = useState({
    search: "",
    type: "",
    from: "",
    to: "",
    status: "",
    employeeId: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [accountsData, setAccountsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 100 }));
    fetchAccounts();
  }, [dispatch]);

  const fetchAccounts = async () => {
    try {
      setLoading(true);
      const superAdminId = localStorage.getItem("adminuserId") || 14;
      const response = await axios.get(`https://payyug.in/api/get-all-saving-account`, {
        params: { superAdminId },
      });
      setAccountsData(response?.data?.accounts || []);
    } catch (err) {
      setError("Failed to load saving accounts.");
    } finally {
      setLoading(false);
    }
  };

  // Function to Trigger Filtering
  const handleApplyFilter = () => {
    setAppliedFilters({
      search: searchQuery,
      type: accountType,
      from: fromDate,
      to: toDate,
      status: selectedStatus,
      employeeId: selectedEmployee?.id || "",
    });
    setCurrentPage(1); // Reset to first page
  };

  // Reset Function
  const handleReset = () => {
    setSearchQuery("");
    setAccountType("");
    setFromDate("");
    setToDate("");
    setSelectedStatus("");
    setSelectedEmployee("");
    setAppliedFilters({
      type: "",
      from: "",
      to: "",
      status: "",
      employeeId: "",
    });
    setCurrentPage(1);
  };

  // Filtering Logic (Ab ye appliedFilters par depend karta hai)
  const filteredData = useMemo(() => {
    let data = [...accountsData];

    if (appliedFilters.employeeId) {
      data = data.filter((item) => item.createdBy === appliedFilters.employeeId);
    }

    if (appliedFilters.status) {
      data = data.filter(
        (item) => item.status && item.status.toLowerCase() === appliedFilters.status.toLowerCase()
      );
    }

    if (searchQuery.trim()) {
      data = data.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase()),
      );
    }

    if (appliedFilters.type) {
      data = data.filter(
        (item) => item.accountType && item.accountType.toLowerCase() === appliedFilters.type.toLowerCase()
      );
    }

    if (appliedFilters.from) {
      data = data.filter((item) => item.openedDate && new Date(item.openedDate) >= new Date(appliedFilters.from));
    }

    if (appliedFilters.to) {
      data = data.filter((item) => item.openedDate && new Date(item.openedDate) <= new Date(appliedFilters.to));
    }

    return data;
  }, [accountsData, appliedFilters,searchQuery]);

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Approve Account API
  const approveAccount = async (id) => {
    try {
      const adminId = localStorage.getItem("adminuserId") || 1;

      await axios.put(
        // `https://payyug.in/api/saapproveSavingAccount/${id}`,
        `https://payyug.in/api/create-saving-account/approve/${id}`,
        { approvedBy: adminId },
      );

      alert("Account Approved Successfully!");
      fetchAccounts();
    } catch (error) {
      console.error("Approve Error:", error);
      alert("Failed to approve account");
    }
  };

  // Reject Account API
  const rejectAccount = async (id) => {
    const adminId = localStorage.getItem("adminuserId") || 1;
    const reason = prompt("Enter Reject Reason:");

    if (!reason) return alert("Reject reason is required!");

    try {
      await axios.put(
        // `https://payyug.in/api/saving-account/reject/${id}`,
        `https://payyug.in/api//create-saving-account/reject/${id}`,
        { rejectedBy: adminId, rejectReason: reason },
      );

      alert("Account Rejected Successfully!");
      fetchAccounts();
    } catch (error) {
      console.error("Reject Error:", error);
      alert("Failed to reject account");
    }
  };

  // delete account
  const handleDelete = async (accountId, accountNo) => {
    const confirm = window.confirm(
      `Are you sure to delete this Account= ${accountNo}`,
    );
    if (confirm) {
      const result = await axios.delete(
        `https://payyug.in/api/delete-saving-account/${accountId}`,
      );
      toast.success(
        result?.data?.message || `Successfully Deleted ${accountNo}`,
      );
    }
    fetchAccounts();
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div className="saving-account-report-container">
      <section className="saving-account-report-filter-section">
        <h2 style={{ textAlign: "center", marginBottom: 10 }}>Saving/Current Account Report</h2>

        <div className="saving-account-report-filter-inputs-wrapper">
          {/* Employee Select */}
          <div className="saving-account-report-filter-input-group">
            <label>Select Employee</label>
            <select
              value={selectedEmployee?.id || ""}
              onChange={(e) => {
                const val = e.target.value;
                setSelectedEmployee(val === "" ? "" : employee?.find((em) => em.id === Number(val)));
              }}
            >
              <option value="">All Employees</option>
              {employee?.map((e) => (
                <option key={e.id} value={e.id}>{e.fullName}</option>
              ))}
            </select>
          </div>

          <div className="saving-account-report-filter-input-group">
            <label>Select Types</label>
            <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
              <option value="">All Account Types</option>
              <option value="Saving">Saving</option>
              <option value="Current">Current</option>
            </select>
          </div>

          <div className="saving-account-report-filter-input-group">
            <label>From Date</label>
            <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
          </div>

          <div className="saving-account-report-filter-input-group">
            <label>To Date</label>
            <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
          </div>

          <div className="saving-account-report-filter-input-group">
            <label>Select Status</label>
            <select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
              <option value="">Select Status</option>
              <option value="pending">Pending</option>
              <option value="active">Active</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "15px" }}>
          <button 
            onClick={handleApplyFilter} 
            style={{ padding: "8px 20px", backgroundColor: "#28a745", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}
          >
            Apply Filter
          </button>
          <button 
            onClick={handleReset} 
            style={{ padding: "8px 20px", backgroundColor: "#dc3545", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}
          >
            Reset
          </button>
        </div>
      </section>

      <div className="saving-account-report-search-section">
        <div>
          <label>Show </label>
          <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
            {ITEMS_PER_PAGE_OPTIONS.map((count) => (
              <option key={count} value={count}>
                {count}
              </option>
            ))}
          </select>
          <span> entries</span>
        </div>
        <input
          type="text"
          placeholder="Search by Account No / Customer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Filters */}
      {/* <div className="SR-filter-box">
        <input
          type="text"
          placeholder="Search name, account no..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
          <option value="">All Account Types</option>
          <option value="Saving">Saving</option>
          <option value="Current">Current</option>
        </select>

        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

        <button className="SR-apply" onClick={() => setCurrentPage(1)}>Apply</button>
        <button
          className="SR-reset"
          onClick={() => {
            setSearchQuery("");
            setAccountType("");
            setFromDate("");
            setToDate("");
            setActiveTab("All");
          }}
        >
          Reset
        </button>
      </div> */}

      {loading && <p className="SR-loading">Loading accounts...</p>}
      {error && <p className="SR-error">{error}</p>}

      {/* Table */}
      <div className="SR-table-wrapper">
        <table className="SR-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Account No</th>
              <th>Customer Name</th>
              <th>Account Type</th>
              <th>Scheme Name</th>
              <th>Opening Date</th>
              <th>Opening Balance</th>
              <th>Current Balance</th>
              <th>Refer ID</th>
              <th>Nominee ID</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{item.accountNumber || "N/A"}</td>
                  <td>{item.customerName || "N/A"}</td>
                  <td>{item.accountType || "N/A"}</td>
                  <td>{item?.schemeDetails?.serviceName || "N/A"}</td>
                  <td>
                    {item.openedDate
                      ? new Date(item.openedDate).toLocaleDateString("en-GB")
                      : "N/A"}
                  </td>
                  <td>₹{item.openingBalance || "0"}</td>
                  <td>₹{item.currentBalance || "0"}</td>
                  <td>{item.referId || "N/A"}</td>
                  <td>{item.nomineeId || "N/A"}</td>
                  <td>{item.status || "N/A"}</td>
                  <td>
                    {item.status?.toLowerCase() === "pending" ? (
                      "After Verify"
                    ) : (
                      <button
                        style={{ color: "red", backgroundColor: "transparent" }}
                        onClick={() =>
                          handleDelete(item.id, item.accountNumber)
                        }
                      >
                        <Trash />
                      </button>
                    )}
                  </td>

                  {/* FIXED: Action Column */}
                  {/* <td>
                    <div className="SR-action-btns">
                      {item.status === "Pending" ? (
                        <>
                          <button
                            className="SR-approve-btn"
                            onClick={() => approveAccount(item.id)}
                          >
                            Accept
                          </button>

                          <button
                            className="SR-reject-btn"
                            onClick={() => rejectAccount(item.id)}
                          >
                            Reject
                          </button>
                        </>
                      ) : (
                        <span className="SR-status-label">{item.status}</span>
                      )}
                    </div>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {activeTab === "All" && filteredData.length > itemsPerPage && (
        <div className="SR-pagination">
          <button
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default SavingReport;
